const styles = theme => ({
  footerButton: {
    margin: '0px',
    background: 'transparent',
    border: 'none',
    height: 50,
    width: 80,
    '&:hover': {
      background: 'transparent',
    },
    '&:focus': {
      background: '#FFFFFF1A',
    },
  },
  isSelected: {
    background: '#FFFFFF1A',
    '& svg': {
      opacity: 1,
    },
  },
  buttonIcon: {
    height: 20,
    width: 20,
    opacity: 0.5,
  },
  dividerImage: {
    height: '20px',
    bottom: '42px',
    width: '100%',
    position: 'fixed',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  historyDrawer: {
    '& .ant-drawer-close': {
      display: 'none',
    },
    '& .ant-drawer-content': {
      overflow: 'inherit',
    },
  },
  divider: {
    position: 'absolute',
    width: '100%',
    height: 30,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    top: 40,
  },
  previousIcon: {
    color: 'white',
    fontWeight: 700,
  },
  drawerTitleArea: {
    display: 'flex',
    width: '100%',
    color: 'white',
    justifyContent: 'space-between',
  },
  closeIcon: {
    color: 'white',
    transform: 'rotate(45deg)',
    fontSize: 25,
    cursor: 'pointer',
  },
  emojiPanelContainer: {
    width: '100%',
  },
  spinner: {
    width: '100%',
    paddingTop: '20px',
  },
  hidden: {
    display: 'none',
  },
  message: {
    fontSize: '14px',
    textAlign: 'center',
    display: 'block',
    padding: '20px',
  },
});

export default styles;
